module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/featured_image@2x.94c4140.jpg";